import { APP_CONSTANTS } from "@core/constants/app-constants";
import { useI18n } from "@core/i18n/i18n";
import styled from "@emotion/styled";
import { BaseDialog, DIALOG_SIZE } from "@ui/components/dialog/base-dialog";
import { DialogProps } from "primereact/dialog";
import React from "react";

const SPACE_SEPARATOR = " ";

export type AboutPhysiomeDialogProps = DialogProps;

export const AboutPhysiomeDialog = (props: AboutPhysiomeDialogProps): JSX.Element => {
	const { format } = useI18n();

	return (
		<BaseDialog header={format("home.aboutPhysiomeDialog.header")} width={DIALOG_SIZE.S} {...props}>
			<Version>
				{format("home.aboutPhysiomeDialog.content.productVersion.intro") + SPACE_SEPARATOR}
				<span className="p-size-s-bold">{APP_CONSTANTS.APP_VERSION}</span>
			</Version>
			<Version>
				{format("home.aboutPhysiomeDialog.content.buildVersion.intro") + SPACE_SEPARATOR}
				<span className="p-size-s-bold">{process.env.BUILD_VERSION ?? `build-${process.env.ENVIRONMENT}`}</span>
			</Version>
		</BaseDialog>
	);
};

const Version = styled.p`
	margin: 16px 0;
`;
